import React, { Component } from "react";
import Loader from "../../Assets/Logo/Loader.gif";

class FormLoader extends Component {
  render() {
    return <img src={Loader} alt="Loader" style={{ width: 50, height: 50 }} />;
  }
}

export default FormLoader;
